module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.c002a58f.woff";